export default "__VITE_ASSET__DD_JC5AB__"